module.exports = __webpack_public_path__ + "img/gzh1.5c7cf3c6.svg";